import React from 'react';
import categories from './CbPunchoutCategories.json';
import { Link } from 'react-router-dom';

export const CbPunchoutCategories = ({ containerObject, templateName, contentId, dataZone }) => {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={` ${containerObject.attributes.articleContainerRendering} ${containerObject.attributes.class} vast-plugin-content row g-0 mb-2 d-lg-block d-none`}>
            <div className="tab">
                <div className="c-category-tabs">
                    <div className="nav nav-tabs d-none d-md-flex">
                        <button className="nav-link active h-100 border-bottom-0" id="homepage-browse-tab0" data-bs-toggle="tab" data-bs-target="#homepage-browse-tab-pane0" type="button"
                            role="tab" aria-controls="homepage-browse-tab-pane0" aria-selected="true">
                            Top Categories for DonorsChoose.org
                        </button>
                        <button className="nav-link h-100 border-bottom-0" id="homepage-browse-tab1" data-bs-toggle="tab" data-bs-target="#homepage-browse-tab-pane1" type="button"
                            role="tab" aria-controls="homepage-browse-tab-pane1" aria-selected="false">
                            Top Picks for DonorsChoose.org
                        </button>
                    </div>
                </div>
            </div>
            <div className="tab-content">
                <div className="tab-pane fade show active" id="homepage-browse-tab-pane0" role="tabpanel" aria-labelledby="homepage-browse-tab0">
                    {/* Content for Top Categories goes here */}
                    <div className="m-auto row mt-4">
                        {categories && categories.topCategories.map((value, key) => {
                            return (
                                <div className="col-4" key={key}>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 browse-top-image mt-3">
                                            <Link to={value && value.categoryImageUrl}><img src={value && value.categoryImage} alt={value && value.categoryName} /></Link>
                                        </div>
                                        <div className="col-lg-9 col-md-9">
                                            <h3 style={{ lineHeight: '0.7' }} className="cb-title my-2"><Link to={value && value.categoryImageUrl}>{value && value.categoryName}</Link></h3>
                                            <p className="cb-info my-0">{value && value.categoryDescription}</p>
                                            <ul className="list-unstyled c-top-cat-links">
                                                {value.childCategories ? Object.entries(value.childCategories).map(([key, value], i) => {
                                                    return (
                                                        <li key={i}><Link to={value.categoryUrl}>{value.categoryName}{value.categoryName === "View All" ? <i className="fas fa-angle-double-right" style={{ marginLeft: '2px', fontSize: '9px' }}></i> : ""}</Link></li>
                                                    )
                                                }) : ''}
                                            </ul>
                                        </div>
                                        <div className="col-lg-2 col-md-0" />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {/* Content for Top Brands goes here */}
                <div className="tab-pane fade" id="homepage-browse-tab-pane1" role="tabpanel" aria-labelledby="homepage-browse-tab1">
                    <div className="m-auto row mt-4">
                        {/* {categories && categories.topCategories.map((value, key) => {
                            return (
                                <div className="col-4" key={key}>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 browse-top-image mt-3">
                                            <Link to={value && value.categoryImageUrl}><img src={value && value.categoryImage} alt={value && value.categoryName} /></Link>
                                        </div>
                                        <div className="col-lg-9 col-md-9">
                                            <h3 style={{ lineHeight: '0.7' }} className="cb-title my-2"><Link to={value && value.categoryImageUrl}>{value && value.categoryName}</Link></h3>
                                            <p className="cb-info my-0">{value && value.categoryDescription}</p>
                                            <ul className="list-unstyled c-top-cat-links">
                                                {value.childCategories ? Object.entries(value.childCategories).map(([key, value], i) => {
                                                    return (
                                                        <li key={i}><Link to={value.categoryUrl}>{value.categoryName}{value.categoryName === "View All" ? <i className="fas fa-angle-double-right" style={{ marginLeft: '2px', fontSize: '9px' }}></i> : ""}</Link></li>
                                                    )
                                                }) : ''}
                                            </ul>
                                        </div>
                                        <div className="col-lg-2 col-md-0" />
                                    </div>
                                </div>
                            )
                        })} */}
                    </div>
                </div>
            </div>
        </div>
    )
}